import PageLoadedQueue
    from "../../../../../../Solutions.Neos.Site/Resources/Private/Assets/JavaScript/Project/PageLoadedQueue";
import {Toast} from "bootstrap";
import Cropper from 'cropperjs';
import imageCompression from "browser-image-compression";

export function UploadProfilePicture() {
    let cropper;

    /**
     * Preview the uploaded image
     */
    function previewUploadedImage() {
        const fileInput = document.getElementById('profile-image-update-upload-field') as HTMLInputElement;
        const previewContainer = document.getElementById('profile-image-preview-container') as HTMLElement;
        const imagePreview = previewContainer?.querySelector('#profile-image-preview') as HTMLImageElement;

        if (!fileInput || !imagePreview || !previewContainer) {
            return;
        }

        previewContainer.classList.add('d-none');

        fileInput.addEventListener('change', () => {
            const file = fileInput.files[0];
            const reader = new FileReader();

            reader.onload = () => {
                imagePreview.src = reader.result as string;
                if (cropper) {
                    cropper.destroy();
                }

                cropper = new Cropper(imagePreview, {
                    aspectRation: 1 / 1,
                    viewMode: 1,
                    autoCropArea: 1,
                    autoCrop: 1,
                });

                previewContainer.classList.remove('d-none');
            }

            reader.readAsDataURL(file);
        });
    }

    /**
     * Upload a new profile picture
     */
    function uploadNewProfilePicture() {
        const form = document.getElementById('solutions-experts-profile-upload-profile-picture-form') as HTMLFormElement;
        const fileInput = document.getElementById('profile-image-update-upload-field') as HTMLInputElement;

        if (!form || !fileInput) {
            return;
        }

        const modal = fileInput.closest('#upload-profile-picture-modal') as HTMLElement;

        form.addEventListener('submit', async (event) => {
            event.preventDefault();

            cropper.getCroppedCanvas({
                minWidth: 256,
                minHeight: 256,
                maxWidth: 1024,
                maxHeight: 1024,
            }).toBlob(async function (blob) {
                // compress image
                const compressedBlob = await imageCompression(blob, {
                    maxSizeMB: 1,
                    maxWidthOrHeight: 1024,
                    useWebWorker: true,
                });

                const image = new File([compressedBlob], 'profile-picture.jpg', {
                    type: 'image/jpeg',
                    lastModified: Date.now()
                });

                const successToastElement = document.getElementById('update-profile-picture-toast-success') as HTMLElement;
                const failedColumn = document.getElementById('update-profile-picture-column-failure') as HTMLElement;
                document.body.append(successToastElement);

                const formData = new FormData(form);
                formData.set('uploadedProfilePicture', image);

                const response = await fetch(form.action, {
                    method: 'POST',
                    body: formData
                })
                    .then((response) => {
                        // reset message elements
                        failedColumn.classList.add('d-none');
                        successToastElement.classList.remove('show');

                        if (!response.ok) {
                            throw new Error('response of the upload was not ok - 1713702145');
                        }
                        return response.json();
                    })
                    .then((data) => {
                        if (data.success) {
                            updateProfilePictures(data.uri);

                            if (modal) {
                                const button = modal.querySelector('button[data-bs-dismiss="modal"]') as HTMLButtonElement;
                                button.click();
                            }

                            if (successToastElement) {
                                const toast = Toast.getOrCreateInstance(successToastElement);
                                toast.show();
                            }

                            return;
                        }

                        throw new Error('unknown error - 1713702141');
                    })

                    .catch((error) => {
                        failedColumn.classList.remove('d-none');
                        console.error('Error:', error);
                    });

            }, 'image/jpeg');
        });

    }

    /**
     * Update all profile images on the page
     *
     * @param newUri
     */
    function updateProfilePictures(newUri: string) {
        const allProfileImages = document.querySelectorAll('.profile-image img') as NodeListOf<HTMLImageElement>;

        allProfileImages.forEach((image) => {
            image.src = newUri;
        });
    }

    /**
     * Reset the modal after it has been closed
     */
    function resetProfilePictureModal() {
        const modal = document.getElementById('upload-profile-picture-modal') as HTMLElement;

        if (!modal) {
            return;
        }

        modal.addEventListener('hidden.bs.modal', () => {
            const form = document.getElementById('solutions-experts-profile-upload-profile-picture-form') as HTMLFormElement;
            const previewContainer = document.getElementById('profile-image-preview-container') as HTMLElement;
            const preview = previewContainer?.querySelector('#profile-image-preview') as HTMLImageElement;
            const failedColumn = document.getElementById('update-profile-picture-column-failure') as HTMLElement;

            if (!form) {
                return;
            }

            form.reset();

            if (preview) {
                preview.src = '#';
            }

            if (previewContainer) {
                previewContainer.classList.add('d-none');
            }

            if (failedColumn) {
                failedColumn.classList.add('d-none');
            }
        })
    }

    previewUploadedImage();
    uploadNewProfilePicture();
    resetProfilePictureModal();
}

PageLoadedQueue.addFunction(UploadProfilePicture);
